import { useLocation, Navigate, Outlet, useOutletContext } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth();
    const location = useLocation();
    const outletContext = useOutletContext();
    console.log("Auth  :  ", auth)
    console.log("Allowed roles   :  ",allowedRoles)
    return (
        auth?.roles?.find(role => allowedRoles?.includes(role))
            ? <Outlet context={outletContext} />
            : auth?.user_details
                ? <Navigate to="/unauthorized" state={{ from: '/login' }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;